import slugify from "slugify";

export function slugifyWorkObjectTypeKey(value: string) {
  return slugify(value, {
    lower: true,
    replacement: "_",
    strict: true,
    trim: true,
  }).slice(0, 48);
}
